
const SYSTEMS = {
  DEV: {
    id: 1,
    // base_service_url: 'http://localhost:10236/Service/',
    base_service_url: 'http://localhost/MilchemetMochot/Service/',
    main_email: 'milchemetmochotinfo@gmail.com'
  },
  LOCAL: {
    id: 2,
    base_service_url: 'http://localhost/MilchemetMochot/Service/',
    main_email: 'milchemetmochotinfo@gmail.com'
  },
  WEBIT_TRACK: {
    id: 3,
    base_service_url: 'http://qa.webit-track.com/MilchemetMochot/Service/',
    main_email: 'milchemetmochotinfo@gmail.com'
  },
  WEBIT_QA: {
    id: 4,
    base_service_url: 'http://qa.webit-track.com/MilchemetMochotTest/Service/',
    main_email: 'milchemetmochotinfo@gmail.com'
  },
  QA: {
    id: 5,
    base_service_url: 'http://91.202.169.81/MilchemetMochotQA/Service/',
    main_email: 'milchemetmochotinfo@gmail.com'
  },
  LIVE: {
    id: 6,
    base_service_url: 'https://thebrainswar.com/Service/',
    main_email: 'x93131@gmail.com'
  },
  ARCHIVE: {
    id: 7,
    base_service_url: 'http://91.202.169.81/MilchemetMochotArchive/Service/',
    main_email: 'x93131@gmail.com'
  }
};

const system = localStorage.system;
console.log(system);
export const SYSTEM = SYSTEMS[system];
